const Subscribe = () => import('../components/Subscription-flow/Subscribe');
const HE = () => import('../components/HE-flow/HE');
const OTP = () => import('../components/OTP-flow/OTP');
const Unsub = () => import('../components/Unsub-flow/Unsub');
const StaticConfirmation = () =>
  import('../components/Static-Confirmation/Status');

export var routes = [
  {
    name: 'pin-code',
    path: '/sub/pin-code/:sessionId',
    component: Subscribe,
  },
  {
    name: 'pin-code',
    path: '/sub/status/:paymentStatus/:paymentId/:sessionId',
    component: Subscribe,
    props: {
      isRedirectionFlow: true,
    },
  },
  {
    name: 'header-enrichement-result',
    path: '/sub/he/:sessionId',
    component: HE,
  },
  {
    name: 'otp-initialize-payment',
    path: '/otp/:sessionId',
    component: OTP,
  },
  {
    name: 'otp-initialize-payment',
    path: '/otp/status/:paymentStatus/:paymentId/:sessionId',
    component: OTP,
    props: {
      isRedirectionFlow: true,
    },
  },
  {
    name: 'un-subscribe',
    path: '/unsub/:sessionId',
    component: Unsub,
  },
  {
    name: 'static-confirmation',
    path: '/status/:paymentStatus',
    component: StaticConfirmation,
  },
];
